export type IStripHtmlComments = (content: string) => string;

export function stripHtmlComments(content: string): string {
  if (typeof content !== 'string') return content;
  let contentClean = content.replace(/<!--(?!>)[\S\s]*?-->/g, '');
  contentClean = contentClean.replace(/\\\\/g, String.fromCharCode(92));
  return contentClean;
}
